module.exports = __webpack_public_path__ + "static/media/calendar-icon.b8f85152.svg";